import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsEsiaCheckMixin extends Vue {
  get isEsiaModule() {
    return !!this.$store.getters.hasApiModuleEsia;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isEsiaCheck.ts